import { registerWithEmailAndPassword } from "../../api/signup";
import { submitUserOnboardingApi } from '../onboarding/onboarding.service';

export const registerUserWithEmailAndPasswordCredentials = async (payload: any): Promise<{ response: any; statusCode: number; message: string }> => {
  const response = await registerWithEmailAndPassword(payload) as { response: any; statusCode: number; message: string };
  return response;
};

export { submitUserOnboardingApi };
